import axiosInstance from '../config/axios';

// Get teachers by program ID
export const getTeachersByProgram = (programId) => {
  return axiosInstance.get(`/programs/${programId}/teachers`);
};

// Get teacher details by teacher ID
export const getTeacherDetails = (teacherId) => {
  return axiosInstance.get(`/teachers/${teacherId}`);
};

// Teacher Screen API

export const getAssingedPrograms = (teacherId) => {
  return axiosInstance.get(`/teacher/programs/${teacherId}`);
}

export const getProgramTimeSlots = (ProgramId, teacherId) => {
  return axiosInstance.get(`/teacher/programs/${ProgramId}/time-slots/${teacherId}`);
}

// Get children for a specific time slot (used in attendance)
export const getChildrenForAttendance = ({ time_slot_id, focus_id, day, start_time, end_time, teacher_id }) => {
  return axiosInstance.get('/teacher/attendance/children', {
    params: {
      time_slot_id,
      focus_id,
      day,
      start_time,
      end_time,
      teacher_id
    }
  });
};

// Mark attendance for children
export const markAttendance = (data) => {
  return axiosInstance.post(`/teacher/child/attendance`, data);
};

// Submit feedback for a child
export const submitChildFeedback = (feedbackData) => {
  return axiosInstance.post('/teacher/child/feedback', feedbackData);
};

// Today's Classes
export const getTodayTeacherClasses = (teacherId) => {
  return axiosInstance.get(`/teacher/${teacherId}/today-classes`);
}

// Get feedback for a child
export const getChildFeedback = ({ child_id, month, year, program_id, focus_id }) => {
  return axiosInstance.get('/teacher/child/get-feedback', {
    params: {
      child_id,
      month,
      year,
      program_id,
      focus_id
    }
  });
};